import { useLocalSearchParams } from 'expo-router'
import { useEffect, useRef } from 'react'
import { View } from 'react-native'

import AdvancedFilterView from '@/components/filtering/GridFilterAdvancedView'
import GridFilterView from '@/components/filtering/GridFilterBasicView'
import { useAppStore } from '@/store/useAppStore'

const GridFilterSheet = () => {
  const { type: filterType } = useLocalSearchParams()

  const basicFilters = useAppStore.use.basicFilters()
  const advancedFilters = useAppStore.use.advancedFilters()
  const setBasicFilters = useAppStore.use.setBasicFilters()
  const setAdvancedFilters = useAppStore.use.setAdvancedFilters()

  const basicFiltersRef = useRef(basicFilters)
  const advancedFiltersRef = useRef(advancedFilters)
  basicFiltersRef.current = basicFilters
  advancedFiltersRef.current = advancedFilters

  useEffect(() => {
    if (!filterType) {
      return
    }

    const currentBasic = basicFiltersRef.current
    const currentAdvanced = advancedFiltersRef.current

    if (filterType === 'basic' && !currentBasic.isActive) {
      setBasicFilters({
        ...currentBasic,
        isActive: true,
      })
      setAdvancedFilters({
        ...currentAdvanced,
        isActive: false,
      })
    }

    if (filterType === 'advanced' && !currentAdvanced.isActive) {
      setAdvancedFilters({
        ...currentAdvanced,
        isActive: true,
      })
      setBasicFilters({
        ...currentBasic,
        isActive: false,
      })
    }
  }, [filterType, setAdvancedFilters, setBasicFilters])

  return (
    <View>
      {advancedFilters.isActive && <AdvancedFilterView />}
      {basicFilters.isActive && <GridFilterView />}
    </View>
  )
}

export default GridFilterSheet
